export const SALES_PAYMENT_LIST_REQUEST = 'SALES_PAYMENT_LIST_REQUEST';
export const SALES_PAYMENT_LIST_SUCCESS = 'SALES_PAYMENT_LIST_SUCCESS';
export const SALES_PAYMENT_LIST_FAIL = 'SALES_PAYMENT_LIST_FAIL';
export const SALES_PAYMENT_CREATE_RESET = 'SALES_PAYMENT_CREATE_RESET';

export const SALES_PAYMENT_CREATE_REQUEST = 'SALES_PAYMENT_CREATE_REQUEST';
export const SALES_PAYMENT_CREATE_SUCCESS = 'SALES_PAYMENT_CREATE_SUCCESS';
export const SALES_PAYMENT_CREATE_FAIL = 'SALES_PAYMENT_CREATE_FAIL';

export const SALESPAYMENT_LIST_REQUEST = 'SALESPAYMENT_LIST_REQUEST';
export const SALESPAYMENT_LIST_SUCCESS = 'SALESPAYMENT_LIST_SUCCESS';
export const SALESPAYMENT_LIST_FAIL = 'SALESPAYMENT_LIST_FAIL';